import { LinearProgress } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

/**
 * Полоса прогресса с видимой незаполненной частью.
 *
 * Штатный LinearProgress красит дорожку светлым оттенком основного цвета, а в
 * теме проекта «основной» — фиолетовый бренда: на шестипиксельной полосе мягкая
 * фиолетовая дорожка и сплошная фиолетовая полоса сливаются, и четверть
 * прогресса выглядит как целое. Дорожке нужен нейтральный тон — divider, он же
 * умеет тёмную тему.
 */
export function ProgressBar({
  value,
  height = 8,
  sx,
}: {
  /** 0..100; выход за границы срезается */
  value: number
  height?: number
  sx?: SxProps<Theme>
}) {
  const safe = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0

  return (
    <LinearProgress
      variant="determinate"
      value={safe}
      sx={{
        height,
        borderRadius: 99,
        backgroundColor: 'divider',
        '& .MuiLinearProgress-bar': { borderRadius: 99 },
        ...sx,
      }}
    />
  )
}
